import { COUNTRY_BOUNDS } from '../constants';

export const getCountryBounds = (countryCode: string = '') => (
  COUNTRY_BOUNDS[countryCode]
);